import React from "react";

/**
 * Runs `reset` DURING RENDER when `key` differs from the key it was last applied for —
 * React's sanctioned "adjust state on prop change" pattern (a setState during render of
 * the same component re-runs it immediately, before children render).
 *
 * The alternative, resetting in an effect, commits one render with the old state under
 * the new key. Children mounted in that render start their effects (fetches) before the
 * parent's effect corrects the state — the exact window ContentBodyLibraries used to
 * expose. `reset` must only call setters of the calling component.
 */
export const useResetOnKeyChange = (key: string, reset: () => void): void => {
    const [appliedKey, setAppliedKey] = React.useState<string>(key);
    if (appliedKey !== key) {
        setAppliedKey(key);
        reset();
    }
};
